import React from "react";
import styled from 'styled-components'
import { breakpoint } from 'styled-components-breakpoint';

const PageContainer = styled.div`
    margin: 0 auto;
    width: 100%;
    position: relative;
    ${breakpoint('mobile')`
        max-width: 1024px;
    `}
`
function PageWrapper(props) {   

    return (
        <PageContainer sticky={true}>
            {props.children}
        </PageContainer>
    )

}
export default PageWrapper;

